export default __webpack_public_path__ + "static/media/september2024-5.aab046b9.jpg";